import type { CandidateContext } from './candidateContext';

export type CandidateRequestTransport = {
  id: string;
  matchesLocation: (pathname: string, search: string) => boolean;
  mapRequestUrl: (url: string) => string;
  canonicalRequestUrl: (url: string) => string;
  mapLaunchUrl?: (url: string) => string;
};
const transports = new Map<string, CandidateRequestTransport>();

export function mapCandidateLaunchUrl(
  url: string,
  context: CandidateContext | null
): string {
  if (!context?.transportId) return url;
  return transports.get(context.transportId)?.mapLaunchUrl?.(url) ?? url;
}

export function canonicalCandidateRequestUrl(url: string): string {
  for (const transport of transports.values()) {
    const canonical = transport.canonicalRequestUrl(url);
    if (canonical !== url) return canonical;
  }
  return url;
}

export function registerCandidateRequestTransport(
  transport: CandidateRequestTransport
): void {
  transports.set(transport.id, transport);
}

export function bindCandidateRequestTransport(
  context: CandidateContext | null
): CandidateContext | null {
  if (!context || context.transportId || typeof window === 'undefined')
    return context;
  for (const transport of transports.values()) {
    if (
      transport.matchesLocation(
        window.location.pathname,
        window.location.search
      )
    ) {
      return { ...context, transportId: transport.id };
    }
  }
  return context;
}

export function mapCandidateRequestUrl(
  url: string | undefined,
  context: CandidateContext | null
): string | undefined {
  if (!url || !context?.transportId) return url;
  return transports.get(context.transportId)?.mapRequestUrl(url) ?? url;
}
